// Include jQuery plugins
//require('jquery.sample');

// Import non-jQuery modules
//const sample = require('sample');

// Define wp_localize_script handles
/* global google alandspersienn Swiper */

(function($) {
    const wntrTheme = {
        body: $('body'),
        html: $('html'),
        document: $(document),
        mapStyle: [
            {
                "featureType": "all",
                "elementType": "labels.text",
                "stylers": [
                    {
                        "color": "#878787"
                    }
                ]
            },
            {
                "featureType": "all",
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "all",
                "stylers": [
                    {
                        "color": "#F0EDE6"
                    },
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "geometry",
                "stylers": [
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "labels.text",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "all",
                "stylers": [
                    {
                        "color": "#f5f5f5"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "color": "#c9c9c9"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "all",
                "stylers": [
                    {
                        "color": "#C3CFD8"
                    }
                ]
            }
        ],

        /**
         * Initialise theme JS on page load
         */
        init: function() {
            // Do we have JS?
            $('html').removeClass('no-js');

            // Automatically call all methods that start with __, in the order they're defined
            for(const prop in wntrTheme) {
                if(prop.startsWith('__') && typeof wntrTheme[prop] === 'function') {
                    wntrTheme[prop].call();
                }
            }
        },

        __toggleMobieMenuHandler: () => {
            const mobileBtn = wntrTheme.body.find('.header__toggle-menu');
            const mobileMenu = wntrTheme.body.find('.mobile-menu');
            mobileBtn.on('click', function() {
                mobileBtn.toggleClass('is-active');
                mobileMenu.toggleClass('is-active');
                wntrTheme.body.toggleClass('is-fixed');
            });
        },

        __swiperHandler: () => {
            if(wntrTheme.body.find('.facebook-feed__facebook-posts')) {
                new Swiper('.facebook-feed__post-wrapper', {
                    slidesPerView: 1.5,
                    direction: 'horizontal',
                    loop: false,
                    spaceBetween: 20,
                    breakpoints: {
                        720: {
                            slidesPerView: 1.5,
                            spaceBetween: 20
                        },
                        1024: {
                            slidesPerView: 2,
                            spaceBetween: 30
                        },
                        1488: {
                            slidesPerView: 3,
                            spaceBetween: 50
                        },
                    },
                });
            }

            if(wntrTheme.body.find('.process__wrapper')) {
                new Swiper('.process__wrapper', {
                    direction: 'horizontal',
                    loop: false,
                    slidesPerView: 1.5,
                    spaceBetween: 20,
                    breakpoints: {
                        720: {
                            slidesPerView: 3.3,
                            spaceBetween: 20
                        },
                        1024: {
                            slidesPerView: 2.3,
                            spaceBetween: 30
                        },
                        1448: {
                            slidesPerView: 3.3,
                            spaceBetween: 50
                        },
                    },
                });
            }
        },

        /**
         * Google Maps
        */
        __initGoogleMaps: () => {
            const map = wntrTheme.body.find('#google-maps__map');

            if(map.length) {

                const latitude = parseFloat(map.data('latitude'));
                const longitude = parseFloat(map.data('longitude'));
                const pin = map.data('pin');
                const address = map.data('address');
                let icon = undefined;
                let zoom = 15;

                if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                    zoom = 14;
                    icon = {
                        url: alandspersienn.get_template_directory_uri + '/src/images/pin.svg',
                        size: new google.maps.Size(25, 25), scaledSize: new google.maps.Size(25, 25)
                    };
                } else {
                    icon = {
                        url: alandspersienn.get_template_directory_uri + '/src/images/pin.svg',
                        size: new google.maps.Size(35, 35), scaledSize: new google.maps.Size(35, 35)
                    };
                }

                const mapObject = new google.maps.Map(document.getElementById('google-maps__map'), {
                    zoom: zoom,
                    disableDefaultUI: true,
                    center: new google.maps.LatLng(latitude, longitude),
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                    gestureHandling: 'cooperative',
                    styles: wntrTheme.mapStyle
                });

                const infowindow = new google.maps.InfoWindow({
                    content: '<div class="marker"><h2 class="marker__title heading-3">Ålands Persienn</h2><h3 class="marker__address">' + address + '</h3><a href="' + pin + '"target="_blank" rel="noopener norefferer" class="marker__link">Visa i Google Maps</a></div>'
                });

                const marker = new google.maps.Marker({
                    position: new google.maps.LatLng(latitude, longitude),
                    animation: google.maps.Animation.DROP,
                    icon: icon,
                    map: mapObject
                });

                infowindow.open(map, marker);

            }
        },
    };

    $(document).ready(wntrTheme.init);
})(jQuery);